module.exports = __webpack_public_path__ + "static/video1_MP4-ff94d1f0e72dc010c65719c79b519261.mp4";